import React from "react";
import { OpacityActionsContainer, OpacityToggleContainer, StyledOpacityButton } from "../sidebar/OpacitySliderStyle";
import { impactLevelInfo } from "../../app/riskLevel";
import { resetLayerVisibilityState, setLayerVisbilityState, useLayerVisibilityState } from "../../features/mapDisplay/mapDisplaySlice";
import { LayerVisibility } from "../risk/geoUtils";
import {
    INVISIBLE_STRING,
    RESET,
    SURFACE_TOGGLE,
    TOGGLE_ICON_LEGEND,
    TOGGLE_ROUTE_VIEW,
    VISIBLE_STRING
} from "../UserVisibleStrings";
import { useDispatch } from "react-redux";
import { StyledButton } from "../risk/bottombar/AdditionalActionsStyle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft, faEye, faEyeSlash } from "@fortawesome/sharp-duotone-light-svg-icons";
import { Tooltip, Switch } from "@mui/material";
import { RiskViewerKind, useRiskViewerStateKind } from "../../features/riskViewer/riskViewerSlice";
import ImpactIcon from "../risk/ImpactIcon";

const OpacityToggle: React.FC = () =>
{
    const LayerEnabledState = useLayerVisibilityState();
    const RiskViewerStateKind = useRiskViewerStateKind();
    const routekey = "Route" as keyof LayerVisibility;
    const iconLegendkey = "IconLegend" as keyof LayerVisibility;
    const dispatch = useDispatch();

    const handleButtonClick = ( level: keyof LayerVisibility ) =>
    {
        // Create a new object to avoid direct state mutation
        const newIsLayerEnabledTracker = { ...LayerEnabledState, [level]: !LayerEnabledState[level] };
        dispatch( setLayerVisbilityState( newIsLayerEnabledTracker ) );
    };

    const renderRiskLevelOpacityToggle = ( level: keyof LayerVisibility ) => (
        <StyledOpacityButton
            key = {`opacityButton${level}`}
            hexbackgroundcolor = {impactLevelInfo[level]?.color}
            onClick = {() => handleButtonClick( level )}
            isVisible = {LayerEnabledState[level]}
        >
            <ImpactIcon level = {level} width = {20} blackAndWhite/>
        </StyledOpacityButton>
    );

    return (
        <OpacityActionsContainer>
            <div style = {{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                <div style = {{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                    <span style = {{ marginLeft: "10px", fontSize: "1.1em" }}>{SURFACE_TOGGLE}</span>
                    <Tooltip title = {RESET}>
                        <StyledButton onClick = {() => dispatch( resetLayerVisibilityState() )} style = {{ marginLeft: "10px" }}>
                            <FontAwesomeIcon icon = {faRotateLeft} size = "sm" fixedWidth/>
                        </StyledButton>
                    </Tooltip>
                </div>

                <OpacityToggleContainer>
                    {Object.keys( LayerEnabledState ).filter( ( level ) => level !== routekey && level !== iconLegendkey ).map( ( level ) => renderRiskLevelOpacityToggle( level as keyof LayerVisibility ) )}
                </OpacityToggleContainer>

                {RiskViewerStateKind === RiskViewerKind.TRIP_STATE && ( // New row for route visibility toggle
                    <div style = {{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                        <span style = {{ marginLeft: "10px", fontSize: "1.1em" }}>{TOGGLE_ROUTE_VIEW}</span>
                        <div style = {{ display: "flex", alignItems: "center" }}>
                            <FontAwesomeIcon icon = {LayerEnabledState.Route ? faEye : faEyeSlash} style = {{ marginRight: "5px" }}/>
                            <span>{LayerEnabledState.Route ? VISIBLE_STRING : INVISIBLE_STRING}</span>
                            <Switch
                                checked = {LayerEnabledState.Route}
                                onChange = {() => handleButtonClick( routekey )}
                                color = "primary"
                            />
                        </div>
                    </div>
                )}

                {RiskViewerStateKind === RiskViewerKind.TRIP_STATE && ( // New row for icon legend visibility toggle
                    <div style = {{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                        <span style = {{ marginLeft: "10px", fontSize: "1.1em" }}>{TOGGLE_ICON_LEGEND}</span>
                        <div style = {{ display: "flex", alignItems: "center" }}>
                            <FontAwesomeIcon icon = {LayerEnabledState.IconLegend ? faEye : faEyeSlash} style = {{ marginRight: "5px" }}/>
                            <span>{LayerEnabledState.IconLegend ? VISIBLE_STRING : INVISIBLE_STRING}</span>
                            <Switch
                                checked = {LayerEnabledState.IconLegend}
                                onChange = {() => handleButtonClick( iconLegendkey )}
                                color = "primary"
                            />
                        </div>
                    </div>
                )}
            </div>
        </OpacityActionsContainer>
    );
};

export default OpacityToggle;
